import { Mic, FileAudio, Video } from "lucide-react";
import { useApp } from "@/lib/i18n";

export const SOURCES = {
  record: [Mic, "bg-rose-100 text-rose-600", "bg-rose-50 text-rose-700", ["Rakaman", "Recording"]],
  upload: [FileAudio, "bg-sky-100 text-sky-600", "bg-sky-50 text-sky-700", ["Muat naik", "Upload"]],
  bot: [Video, "bg-violet-100 text-violet-600", "bg-violet-50 text-violet-700", ["Mesyuarat Online", "Online Meeting"]],
};
const get = (s) => SOURCES[s] || SOURCES.upload;

export const SourceIcon = ({ source, testId }) => {
  const [Icon, cls] = get(source);
  return <div className={`grid h-10 w-10 shrink-0 place-items-center rounded-xl ${cls}`} data-testid={testId} data-source={source || "upload"}><Icon size={17} /></div>;
};

export const SourceChip = ({ source }) => {
  const { L } = useApp();
  const [, , cls, label] = get(source);
  return <span className={`rounded-full px-2 py-0.5 text-[11px] font-semibold ${cls}`} data-testid="meeting-source-chip">{L(...label)}</span>;
};
